export default {"src":"/_next/static/media/thorough-vetting.b6794caa.svg","height":230,"width":287,"blurWidth":0,"blurHeight":0};